export default __webpack_public_path__ + "static/media/factory.ae7d4a71.svg";